import * as Sentry from "@sentry/browser";
import { push } from "connected-react-router";
import timezoneList from "compact-timezone-list";
import { getTimezone } from "countries-and-timezones";
import { takeLatest, call, put } from "redux-saga/effects";

import Auth from "utils/Auth";
import * as authActions from "../actions/AuthActions";
import { trackAnalyticsEvent } from "../actions/AnalyticsActions";

function* login({ credentials }) {
  try {
    if (credentials.accessToken) {
      yield call(Auth.setAccessToken, credentials.accessToken);
    } else {
      yield call(Auth.login, credentials);
    }
    yield call(fetchUserInfo);
    yield put(authActions.setShowSetupAccountModal(true));
    yield put(push("/")); //TODO: Redirect to previous page
  } catch (err) {
    yield put(authActions.loginFailed(err.message));
  }
}

function* logout() {
  try {
    yield call(Auth.logout);
    yield put(push("/"));
  } catch (err) {
    yield put(push("/"));
  }
}

function* fetchUserInfo() {
  try {
    const userInfo = yield call(Auth.getUserInfo);
    yield put(authActions.userInfoFetched(userInfo));
  } catch (err) {
    yield put(authActions.authenticationRequired());
  }
}

function* renewToken() {
  try {
    yield call(Auth.renewToken);
    yield put(authActions.tokenRenewed());
  } catch (err) {
    //Error renewing. Ignore.
  }
}

function identifyUser(action) {
  const { userInfo } = action;
  Sentry.configureScope(scope => {
    scope.setUser({ id: userInfo.id });
  });
}

function* startOnboarding({ accountData }) {
  try {
    // TODO: remove this later
    const { isGoogle } = accountData;
    const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const timezoneData = getTimezone(browserTimezone);
    accountData.timezone =
      timezoneList.find(
        tz =>
          tz.tzCode === timezoneData.name || tz.tzCode === timezoneData.aliasOf
      )?.tzCode || browserTimezone;
    accountData.billingCountry = timezoneData.countries[0];

    yield call(Auth.startOnboarding, accountData);
    const { email, password } = accountData;
    yield call(login, { credentials: { email, password } });
    yield call(
      trackAnalyticsEvent("Trail Started", {
        isGoogle
      })
    );
    yield call(
      trackAnalyticsEvent("New User Created", {
        source: "organic"
        // existingAccount: true
      })
    );
  } catch (err) {
    yield put(authActions.startOnboardingFailed(err.message));
  }
}

function* nonceLogin({ nonce }) {
  try {
    yield call(Auth.nonceLogin, nonce);
    yield call(fetchUserInfo);
    yield put(authActions.nonceLoginSuccess());
  } catch (err) {
    yield put(authActions.nonceLoginFailed());
  }
}

function* resetPassword({ email }) {
  try {
    yield call(Auth.resetPassword, email);
    yield put(authActions.resetPasswordSent());
  } catch (err) {
    //TODO: Do something else...
    yield put(authActions.resetPasswordFailed(err.message));
  }
}

function* updateUser({ values }) {
  try {
    const userInfo = yield call(Auth.updateUserInfo, values);
    yield put(authActions.userInfoFetched(userInfo));
  } catch (err) {}
}

function* updatePhone({ values }) {
  try {
    const userInfo = yield call(Auth.updatePhoneInfo, values);
    yield put(authActions.userInfoFetched(userInfo));
  } catch (err) {
    yield put(authActions.updatePhoneFailed(err.message));
  }
}

export default function* root() {
  yield takeLatest(authActions.LOGIN, login);
  yield takeLatest(authActions.LOGOUT, logout);
  yield takeLatest(authActions.RENEW_TOKEN, renewToken);
  yield takeLatest(authActions.USER_INFO_REQUESTED, fetchUserInfo);
  yield takeLatest(authActions.USER_INFO_FETCHED, identifyUser);
  yield takeLatest(authActions.START_ONBOARDING, startOnboarding);
  yield takeLatest(authActions.NONCE_LOGIN, nonceLogin);
  yield takeLatest(authActions.RESET_PASSWORD, resetPassword);
  yield takeLatest(authActions.UPDATE_USER, updateUser);
  yield takeLatest(authActions.UPDATE_PHONE, updatePhone);
}
